<template>
  <el-row :gutter="15">
    <el-col
      :xs="7"
      :sm="6"
      :md="6"
      :lg="5"
      :xl="5"
    >
      <Filters
        v-model="filters"
        :resource="$sdk.attachment"
        :primary-fields="[ 'file.name', 'file.type', 'file.creator', 'created_at' ]"
        @apply="$refs.table.loadTable()"
        @ready="$refs.table.loadTable()"
      />
    </el-col>

    <el-col
      :xs="17"
      :sm="18"
      :md="18"
      :lg="19"
      :xl="19"
    >
      <el-card
        shadow="never"
      >
        <AttachmentsTable
          ref="table"
          :consignment-id="$route.params.consignmentId"
          :filters="filters"
        />
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import Filters from '@/components/Filters/Simplified'
import AttachmentsTable from '@/components/Application/Freight/Consignments/Attachments/AttachmentsTable'
import Request, { GET } from '@/plugins/sdk/Request'
import Vue from 'vue'
import PDFDialog from '@/components/Application/Freight/Consignments/Attachments/PDFDialog'

export default {
  components: {
    Filters,
    AttachmentsTable
  },
  data () {
    return {
      pdfDialogVisible: false,
      isLoadingLabel: false,
      actions: [
        [
          {
            name: 'Upload & Attach',
            icon: ['fal', 'upload'],
            event: () => {
              this.$refs.table.$refs.uploadForm.isShow = true
            }
          },
          {
            name: 'Refresh',
            icon: ['fal', 'sync'],
            event: () => this.$refs.table.loadTable()
          }
        ],
        [
          {
            name: 'Print',
            icon: ['fal', 'print'],
            dropdown: {
              actions: [
                {
                  name: 'Print Label',
                  icon: ['fal', 'file'],
                  event: this.printLabel,
                  loading: this.isLoadingLabel
                },
                {
                  name: 'Print Connote',
                  icon: ['fal', 'file'],
                  event: this.printConnote
                },
                {
                  name: 'Print Manifest',
                  icon: ['fal', 'file'],
                  event: this.printManifest
                },
                {
                  name: 'Print DG',
                  icon: ['fal', 'file'],
                  event: this.printDG
                }
              ]
            }
          }
        ]
      ],
      breadcrumb: {
        name: 'Attachments',
        route: { name: 'freight-consignments-v3-consignment-attachments', params: { consignmentId: this.$route.params.consignmentId } }
      },
      filters: []
    }
  },
  methods: {
    async printLabel () {
      this.isLoadingLabel = true
      const request = Object.assign(new Request(), {
        _pathname: `/legacy/label?consignment=${this.$route.params.consignmentId}`,
        method: GET
      })
      let res = await fetch(await request.build())
      let data = await res.json()

      if (data.label_pdf) {
        this.openPDFDialog(data.label_pdf, 'label')
        this.isLoadingLabel = false
        // window.open(atob(data.label_pdf), '_blank')
      } else {
        this.isLoadingLabel = false
        this.$message.error('No Label Paperwork Generated')
      }
    },
    async printConnote () {
      const request = Object.assign(new Request(), {
        _pathname: `/legacy/label?consignment=${this.$route.params.consignmentId}`,
        method: GET
      })
      let res = await fetch(await request.build())
      let data = await res.json()

      if (data.connote_pdf) {
        window.open(atob(data.connote_pdf), '_blank')
      } else {
        this.$message.error('No Connote Paperwork Generated')
      }
    },
    async printDG () {
      const request = Object.assign(new Request(), {
        _pathname: `/legacy/label?consignment=${this.$route.params.consignmentId}`,
        method: GET
      })
      let res = await fetch(await request.build())
      let data = await res.json()

      if (data.dg_pdf) {
        window.open(atob(data.dg_pdf), '_blank')
      } else {
        this.$message.error('No DG Paperwork Generated')
      }
    },
    async printInvoice () {
      const request = Object.assign(new Request(), {
        _pathname: `/legacy/label?consignment=${this.$route.params.consignmentId}`,
        method: GET
      })
      let res = await fetch(await request.build())
      let data = await res.json()

      if (data.invoice_pdf) {
        window.open(atob(data.invoice_pdf), '_blank')
      } else {
        this.$message.error('No Invoice Paperwork Generated')
      }
    },
    async printManifest () {
      const request = Object.assign(new Request(), {
        _pathname: `/legacy/manifest?consignment=${this.$route.params.consignmentId}`,
        method: GET
      })
      let res = await fetch(await request.build())
      let data = await res.json()

      if (data.manifest_pdf) {
        window.open(atob(data.manifest_pdf), '_blank')
      } else {
        this.$message.error('No Manifest Paperwork Generated')
      }
    },
    openPDFDialog (data, type) {
      const PDFDialogClass = Vue.extend(PDFDialog)

      this.pdfDialogInstance = new PDFDialogClass({
        propsData: {
          isShow: true,
          pdfData: data,
          title: type === 'label' ? 'Label' : type === 'connote' ? 'Connote' : type === 'dg' ? 'Dangerous Goods' : type === 'invoice' ? 'Invoice' : 'Manifest'
        }
      })

      this
        .pdfDialogInstance
        .$on('destroy', () => {
          this.pdfDialogVisible = false
        })

      this
        .pdfDialogInstance
        .$mount()

      this
        .$root
        .$el
        .appendChild(this.pdfDialogInstance.$el)

      this.pdfDialogVisible = true
    }
  }
}
</script>
